{
  "version": 1,
  "asset_id": "026e1270-76aa-4109-a132-5308eb34f5be",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/026e1270-76aa-4109-a132-5308eb34f5be/hiatal-type-1-v3-800.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/026e1270-76aa-4109-a132-5308eb34f5be/hiatal-type-1-v3-800.webp",
  "original_filename": "hiatal-type-1-v3-800.webp",
  "size": 81696,
  "content_type": "image/webp",
  "created_at": "2026-10-28T23:09:29Z"
}
